import { loadStripe } from "@stripe/stripe-js";

// Cache loadStripe() promises per publishable key (Stripe recommends calling it once).
const _cache = {};

export function getStripe(publishableKey, stripeAccount) {
  if (!publishableKey) return null;
  // Direct charges: Stripe.js must target the connected account, so cache per (key + account).
  const cacheKey = stripeAccount ? `${publishableKey}::${stripeAccount}` : publishableKey;
  if (!_cache[cacheKey]) {
    _cache[cacheKey] = loadStripe(publishableKey, stripeAccount ? { stripeAccount } : undefined);
  }
  return _cache[cacheKey];
}
